import * as React from 'react'
import { connect } from 'react-redux'
import { ContactTriggerFlowComponent } from './ContactTriggerFlow'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'
import { listTriggers } from 'features/Flows/Flows.actions'
import { subscribeContactToFlow } from 'features/Contacts/Contacts.actions'
import { IContactClient } from 'features/Contacts/types'

const formName = 'contactTriggerFlow'

export interface IContactEditContainerProps {
  onAfterSubmit: () => undefined
  contact: IContactClient
}

const stateToProps = ({ flows }) => ({
  loading: flows.triggersLoading,
  triggers: flows.triggers,
})

export const dispatchToProps = {
  listTriggers,
  subscribeContactToFlow,
}

export const ContactTriggerFlow = flow<any, any, React.SFC<IContactEditContainerProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(ContactTriggerFlowComponent)



// WEBPACK FOOTER //
// src/features/Contacts/ContactTriggerFlow/ContactTriggerFlow.container.ts